export default __webpack_public_path__ + "static/media/blog-34-image-5.a6b4eb95.jpg";